import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  input: {
    minWidth: 400,
    maxWidth: 600,
  },
}));

function ReasonAutoComplete({
  reasons,
  selectedReason,
  setSelectedReason,
}) {
  const classes = useStyles();

  function handleChange(_, value) {
    setSelectedReason(value);
  }

  return (
    <Autocomplete
      id="po-search-status-autocomplete"
      data-test='po-search-status-autocomplete'
      disabled={false}
      options={ [...reasons, {'ReasonText': 'Custom'}]}
      getOptionLabel={(option) => option.ReasonText}
      value={selectedReason}
      onChange={handleChange}
      style={{width: '100%'}}
      renderInput={(params) => (
        <TextField 
          {...params}
          label="Available Reasons"
          variant="outlined"
          autoFocus={true}
          className={classes.input}
        />
      )}
    />
  );
}

ReasonAutoComplete.propTypes = {
  reasons: PropTypes.arrayOf(PropTypes.shape({
    purchaseOrderReasonId: PropTypes.number,
    ReasonText: PropTypes.string,
  })),
  selectedReason: PropTypes.shape({
    purchaseOrderReasonId: PropTypes.number,
    ReasonText: PropTypes.string,
  }),
  setSelectedReason: PropTypes.func,
};

export default ReasonAutoComplete;
